import { Object3D, Euler, Vector3 } from "three";
import { BasePanel } from "./BasePanel.js";
import Util from "../utils/utils.js";
import {RoadToolVR} from "../utils/RoadTool_VR.js";

const btn_normalPath = "/assets/vrUI/common/btn_normal.png";
const btn_hoverPath = "/assets/vrUI/common/btn_hover.png";
const btn_clickPath = "/assets/vrUI/common/btn_click.png";
const sliderBgPath = "/assets/vrUI/EditPanel_Material/sliderBg1.png";
const sliderHandlePath = "/assets/vrUI/EditPanel_Material/sliderHandle.png";


export class EditPanel_Way extends BasePanel {
  constructor(manager, visible) {
    super(manager, visible);
    this.roadTool=null;
  }

  init() {}

  async initPanel(parent) {
    this.parent = parent;

    this.width = 2.175;
    this.height = 0.7;
    this.container = this.uilib.createContainer({
      opacity: 0,
      width: this.width,
      height: this.height,
      radius: 0,
      dragable: false,
    });
    this.parent.add(this.container);
    this.uiElements.push(this.container);
    this.container.visible = this._visible;

    await this._createWayToolUI();

    if (!this._visible) {
      this.closePanel();
    }

  }

  async _createWayToolUI() {
    const btn_normal = await this.manager.loadManager.loadTexture(
      btn_normalPath
    );
    const btn_hover = await this.manager.loadManager.loadTexture(btn_hoverPath);
    const btn_click = await this.manager.loadManager.loadTexture(btn_clickPath);
    const sliderBg = await this.manager.loadManager.loadTexture(sliderBgPath);
    const sliderHandle = await this.manager.loadManager.loadTexture(sliderHandlePath);

    // 道路宽度
    const widthText = this.uilib.createText({
      text: "道路宽度",
      textColor: 0xffffff,
      font: "normal",
      textSize: 0.035,
    });
    widthText.position.set(-1.0,this.height/2-0.1,0.001)
    this.container.add(widthText);

    const widthSlider = this.uilib.createSlider({
      bgMap: sliderBg,
      handleMap: sliderHandle,
      color:0xffffff,
      handleColor:0xffffff,
      width: 0.8,
      height: 0.05,
    });
    widthSlider.addOnValueChangeEvent((value) => {
      this.roadTool.setRoadWidth(value);
    })
    widthSlider.position.set(-0.5,this.height/2-0.1,0.001)
    this.container.add(widthSlider);

    // 道路高度偏移
    const heightText = this.uilib.createText({
      text: "道路高度",
      textColor: 0xffffff,
      font: "normal",
      textSize: 0.035,
    });
    heightText.position.set(-1.0,this.height/2-0.28,0.001)
    this.container.add(heightText);

    const heightSlider = this.uilib.createSlider({
      bgMap: sliderBg,
      handleMap: sliderHandle,
      color:0xffffff,
      handleColor:0xffffff,
      width: 0.8,
      height: 0.05,
    });
    heightSlider.addOnValueChangeEvent((value) => {
      this.roadTool.setRoadHeightOffset(value);
    })
    heightSlider.position.set(-0.5,this.height/2-0.28,0.001);
    this.container.add(heightSlider);

    // 绘制模式
    const straightLineBtn=this.uilib.createBtn({
      map: btn_normal,
      text: "直线路径",
      textColor: 0xffffff,
      width: 0.4,
      height: 0.08,
      font: "bold",
      stateChangeImage: {
          normal: btn_normal,
          hover: btn_hover,
          click: btn_click,
        }
    })
    straightLineBtn.position.set(-0.75,this.height/2-0.45,0.001)
    this.container.add(straightLineBtn);

    const curveLineBtn=this.uilib.createBtn({
      map: btn_normal,
      text: "曲线路径",
      textColor: 0xffffff,
      width: 0.4,
      height: 0.08,
      font: "bold",
      stateChangeImage: {
          normal: btn_normal,
          hover: btn_hover,
          click: btn_click,
        }
    })
    curveLineBtn.position.set(-0.3,this.height/2-0.45,0.001);
    this.container.add(curveLineBtn);

    straightLineBtn.addClickEvent(()=>{
      this.roadTool.inputLocked = true;
      this.roadTool.setDrawMode('line');
      setTimeout(()=>{
        this.roadTool.inputLocked = false;
      },0)
    })
    curveLineBtn.addClickEvent(()=>{
      this.roadTool.inputLocked = true;
      this.roadTool.setDrawMode('curve');
      setTimeout(()=>{
        this.roadTool.inputLocked = false;
      },0)
    })

    // 确认创建按钮
    const certainBtn=this.uilib.createBtn({
      map: btn_normal,
      text: "确认创建",
      textColor: 0xffffff,
      width: 0.4,
      height: 0.08,
      font: "bold",
      stateChangeImage: {
          normal: btn_normal,
          hover: btn_hover,
          click: btn_click,
        }
    })
    certainBtn.position.set(-0.75,this.height/2-0.6,0.001);
    this.container.add(certainBtn);
    certainBtn.addClickEvent(()=>{
      this.roadTool.inputLocked = true;
      this.roadTool.confirmRoad();
      setTimeout(()=>{
        this.roadTool.inputLocked = false;
      },0)
    })
  }

  closePanel() {
    super.closePanel();

    if(this.roadTool){
      this.roadTool.disable();
    }

    this.manager.interface.setClickMode(0); // 切换到默认模式
  }

  show() {
    super.show();

    if(!this.roadTool){
      this.roadTool = new RoadToolVR(this.manager);
    }

    if(this.roadTool){
      this.roadTool.enable();
    }

    this.manager.interface.setClickMode(4); // 切换到道路模式
  }

  /**
   * 处理VR控制器扳机键按下事件
   * @param {Object} controller VR控制器对象
   */
  onTriggerDown(controller) {
    if (!this.roadTool) return;

    console.log("道路功能手柄点击");
    // 开始修改地形
    this.roadTool.onSelectStart(controller);
  }
}
